import { expaGetClientSideFrozenExpaFromCookie } from '../../expa'
import { useRunCallbackWhenSessionCallIsDone } from '../../user-data'
import { gtmDataLayerPushEventUserDataAvailable } from '../gtmDataLayer'

export const usePushGtmUserDataAvailableEvent = (): void => {
  useRunCallbackWhenSessionCallIsDone((data) => {
    const expaToPush = expaGetClientSideFrozenExpaFromCookie() ?? data?.expa

    gtmDataLayerPushEventUserDataAvailable({
      expa: expaToPush,
    })
  })
}
